import { createStore } from 'effector'

import { IterableUtils } from 'src/entities/iterable/lib/authorization'

export const $hasAuthorization = createStore<boolean>(false)
export const $utils = createStore<IterableUtils | null>(null)
